import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'

interface IProps {
  selected: boolean;
  amount: number;
  onChange: () => void;
}
const PaypalSimpleItem: FC<IProps> = ({ selected, amount, onChange }) => {
  const handleChange = () => {
    onChange()
  }
  return (
    <div
      className={classNames('pay-method-item', 'paypal-web', { selected })}
      data-cypid='paypalSimpleItem'
      onClick={handleChange}
    >
      <div className='card-left'>
        <i className='iconfont icon-paypal'></i>
      </div>

      <div className='card-content'>
        <div className='title-top'>
          <div className='name'>{i18n.t('pay.paypal')}</div>
        </div>
        <div className='amount'>
          {selected && format.toPrice(amount)}
        </div>
      </div>
      <div className='amount-select'>
        <i className={classNames('iconfont', selected ? 'icon-checked' : 'no-select')} />
      </div>
    </div>
  )
}

export default observer(PaypalSimpleItem)
